import React from "react";
import { Link } from "react-router-dom";
import "./Careers.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { useRef } from "react";
import type { Swiper as SwiperType } from "swiper";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

import lifeImage1 from "../../assets/images/6.png";
import lifeImage2 from "../../assets/images/8.png";
import lifeImage3 from "../../assets/images/5.png";
import lifeImage4 from "../../assets/images/grpImage5.jpg";
import lifeImage5 from "../../assets/images/7.png";
import lifeImage6 from "../../assets/images/4.png";
import lifeImage7 from "../../assets/images/grpImage4.jpeg";



const Career: React.FC = () => {
    const swiperRef = useRef<SwiperType | null>(null);
  return (
    <>

    <title>Finsall Careers and Open Roles</title>
<meta
  name="description"
  content="Explore career opportunities at Finsall across tech, operations and insurance premium financing roles, with growth focused on India’s fintech sector."
/>

      <Header />

      <section className="career-top-strip"></section>

      <section className="life-section">

        <div className="life-header">

          <h2>
            Careers at Finsall
          </h2>

          <p>
            We believe our employees underpin our purpose of insuring
            people and businesses of India. And we can clearly see the
            impact we make at regular intervals.
          </p>

        </div>

        <div className="life-carousel-wrapper">

  <Swiper
    modules={[Pagination]}
    loop={true}
    onSwiper={(swiper: SwiperType) => {
  swiperRef.current = swiper;
}}
    pagination={{
      clickable: true,
      el: ".life-pagination",
    }}
    spaceBetween={30}
    slidesPerView={2}
    breakpoints={{
      0: {
        slidesPerView: 1,
      },
      992: {
        slidesPerView: 2,
      },
    }}
    className="life-swiper"
  >

    <SwiperSlide>
      <div className="life-slide">
        <img src={lifeImage1} alt="insall team gathering during an office celebration" />
      </div>
    </SwiperSlide>

    <SwiperSlide>
      <div className="life-slide">
        <img src={lifeImage2} alt="insall team enjoying a group lunch together" />
      </div>
    </SwiperSlide>

    <SwiperSlide>
      <div className="life-slide">
        <img src={lifeImage3} alt="finsall team in the office workspace" />
      </div>
    </SwiperSlide>

    <SwiperSlide>
      <div className="life-slide">
        <img src={lifeImage4} alt="finsall team at an outdoor retreat" />
      </div>
    </SwiperSlide>

    <SwiperSlide>
      <div className="life-slide">
        <img src={lifeImage5} alt="finsall team members at an informal meetup" />
      </div>
    </SwiperSlide>

    <SwiperSlide>
      <div className="life-slide">
        <img src={lifeImage6} alt="finsall office celebration with employees and families" />
      </div>
    </SwiperSlide>

    <SwiperSlide>
      <div className="life-slide">
        <img src={lifeImage7} alt="finsall team during an indoor meetup" />
      </div>
    </SwiperSlide>

  </Swiper>

  <div className="life-controls">

    <button
      className="life-prev"
      onClick={() => swiperRef.current?.slidePrev()}
    >
      ‹
    </button>

    <button
      className="life-next"
      onClick={() => swiperRef.current?.slideNext()}
    >
      ›
    </button>

  </div>

  <div className="life-pagination"></div>

</div>


      </section>

            <section className="career-openings-section">

        <div className="career-openings-header">

          <h2>
            We’ve got big plans....and
            they include you!
          </h2>

          <p>
            Want to bring your fullest self to work?
            Passionate about solving problems?
            We’ve been looking for you.
          </p>

        </div>

        <div className="career-job-card">

          <div className="career-job-header">

            <div>
              <h3>
                Java Backend Developer
              </h3>

              <span>
                Full Time/Permanent
              </span>
            </div>

          </div>

          <p className="career-job-description">
            Designing and developing end to end back end applications
            in java that meet the business requirements in an effective
            and efficient manner. Directly interfacing with the founding
            team and technology team to understand the requirements and
            provide solutions. Assisting & guiding team members in
            design and development.
          </p>

          <div className="career-job-action">

            <Link
              to="/career-detail"
              className="career-role-btn"
            >
              View Roles and Responsibilities
            </Link>

          </div>

        </div>

      </section>

      <Footer />
    </>
  );
};

export default Career;